module.exports = __webpack_public_path__ + "img/select-add.67aa3622.svg";